import { Col, Container, Row, Stack } from "react-bootstrap";
import { CaretDownFill, CaretUpFill } from "react-bootstrap-icons";

export default function ListenerHistoryHeader({ sortConfig, requestSort }) {
    return (
        <Container fluid className="sticky-top">
            <Row className="bg-ra-dark-blue text-white fw-bold py-1 rounded-2 fs-8-xs table-header user-select-none h-100">
                <Col onClick={() => requestSort("station_name")} className=" align-content-center">
                    <Stack direction="horizontal" className="justify-content-center text-center">
                        <span className="offset-1">Station</span>
                        <span className="col-1">
                            {sortConfig?.key === "station_name" && (sortConfig.direction === "descending" ? <CaretDownFill /> : <CaretUpFill />)}
                        </span>
                    </Stack>
                </Col>
                <Col xs={4} xl={5}>
                    <Row>
                        <Col xs={12} xl={6} onClick={() => requestSort("start_datetime")} className=" align-content-center">
                            <Stack direction="horizontal" className="justify-content-center text-center">
                                <span className="offset-1 text-nowrap">Start Datetime</span>
                                <span className="col-1">
                                    {sortConfig?.key === "start_datetime" && (sortConfig.direction === "descending" ? <CaretDownFill /> : <CaretUpFill />)}
                                </span>
                            </Stack>
                        </Col>
                        <Col xs={12} xl={6} onClick={() => requestSort("end_datetime")} className=" align-content-center">
                            <Stack direction="horizontal" className="justify-content-center text-center">
                                <span className="offset-1 text-nowrap">End Datetime</span>
                                <span className="col-1">
                                    {sortConfig?.key === "end_datetime" && (sortConfig.direction === "descending" ? <CaretDownFill /> : <CaretUpFill />)}
                                </span>
                            </Stack>
                        </Col>
                    </Row>
                </Col>
                <Col xs={2} xl={1} onClick={() => requestSort("duration")} className=" align-content-center">
                    <Stack direction="horizontal" className="justify-content-center text-center">
                        <span className="offset-1">Duration</span>
                        <span className="col-1">
                            {sortConfig?.key === "duration" && (sortConfig.direction === "descending" ? <CaretDownFill /> : <CaretUpFill />)}
                        </span>
                    </Stack>
                </Col>
                <Col xs={3}>
                    <Row>
                        <Col xs={12} xl={6} onClick={() => requestSort("in_out")} className=" align-content-center">
                            <Stack direction="horizontal" className="justify-content-center text-center">
                                <span className="offset-1">Location</span>
                                <span className="col-1">
                                    {sortConfig?.key === "in_out" && (sortConfig.direction === "descending" ? <CaretDownFill /> : <CaretUpFill />)}
                                </span>
                            </Stack>
                        </Col>
                        <Col xs={12} xl={6} onClick={() => requestSort("platform")} className=" align-content-center">
                            <Stack direction="horizontal" className="justify-content-center text-center">
                                <span className="offset-1">Platform</span>
                                <span className="col-1">
                                    {sortConfig?.key === "platform" && (sortConfig.direction === "descending" ? <CaretDownFill /> : <CaretUpFill />)}
                                </span>
                            </Stack>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Container>
    );
}
